import { useEffect, useState } from "react";
import { FileField } from "@/ui/FileField";
import { recoLabel, V1_OFFERED } from "@/views/debriefs/vocabulary";
import { Banner, Dialog, Field } from "@/ui";

// §4.15 — somebody who said they cannot attend sends what they would have said in the room, and optionally their
// alignment; the Recruiter reads it in and the reveal sets the row from it.
// B14: the alignment choices are the room's offered set (debrief.open.level.offered), in his words from the one mapping.
export function WrittenInputDialog({ open, rid, offered = V1_OFFERED, candidate, onClose, onSubmit, busy, error }: { open: boolean; rid: string; offered?: readonly string[]; candidate: string; onClose: () => void; onSubmit: (v: { text: string; fileId: string | null; alignment: string }) => void; busy: boolean; error: Parameters<typeof Banner>[0]["error"] }) {
  const [fileId, setFileId] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);
  const [text, setText] = useState("");
  const [alignment, setAlignment] = useState<string>("");
  useEffect(() => {
    if (!open) return;
    setText("");
    setFileId(null);
    setAlignment("");
  }, [open]);
  return (
    <Dialog title="Written input" open={open} onClose={onClose}>
      <p className="mono muted">{candidate}</p>
      <p className="muted">Due before the debrief starts. The Recruiter reads it into the room; the debrief is not rescheduled. Sending it again replaces what you sent before.</p>
      <p>Written input is evidence on the sheet, never a binding alignment. Your alignment stays missing unless you set it yourself.</p>
      {open && <FileField label="Written input document" owner={{ owner_type: "requisition", owner_id: rid, requisition_id: rid, kind: "written_input" }} onChange={(file) => setFileId(file?.file_id ?? null)} onBusy={setUploading} />}
      <Field label="What you would have said" required id="wi-text">
        <textarea id="wi-text" rows={4} value={text} onChange={(e) => setText(e.target.value)} maxLength={8000} />
      </Field>
      <fieldset className="radios">
        <legend>Set my alignment now (optional)</legend>
        {offered.map((v) => (
          <label key={v} className={`opt${alignment === v ? " opt--on" : ""}`}>
            <input type="radio" name="wi-align" checked={alignment === v} onChange={() => setAlignment(v)} /> {recoLabel(v)}
          </label>
        ))}
        <label className={`opt${alignment === "" ? " opt--on" : ""}`}>
          <input type="radio" name="wi-align" checked={alignment === ""} onChange={() => setAlignment("")} /> Leave it blank
        </label>
      </fieldset>
      <Banner error={error} />
      <div className="row row--end" style={{ gap: 8, marginTop: 8 }}>
        <button type="button" className="btn" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn--primary" disabled={busy || uploading || text.trim().length < 3} onClick={() => onSubmit({ text: text.trim(), fileId, alignment })}>
          {busy ? "Sending…" : "Send my written input"}
        </button>
      </div>
    </Dialog>
  );
}
